import { HousingPermissionType } from './enums/housing-permission-type';
import { DropdownStepperParent } from './dropdown-stepper.model';
import { NameValue } from './helpers/name-value.model';
import { StateOfGermany } from './state-of-germany.enum';

export const getWbsOptions = (
  germanyStates: NameValue<StateOfGermany>[]
): DropdownStepperParent<HousingPermissionType>[] => {
  const options: DropdownStepperParent<HousingPermissionType>[] = [];

  germanyStates.forEach(v => {
    const state = v.value;
    switch (state) {
      case StateOfGermany.BADEN_WUERTTEMBERG:
        options.push(
          getWbsItems(state, [
            HousingPermissionType.BADEN_WUERTTEMBERG_WOSU_EMERGENCY_CERTIFICATE
          ])
        );
        break;
      case StateOfGermany.BAVARIA:
        options.push(
          getWbsItems(state, [
            HousingPermissionType.BAVARIA_EOF_INCOME_GROUP_1,
            HousingPermissionType.BAVARIA_EOF_INCOME_GROUP_2,
            HousingPermissionType.BAVARIA_EOF_INCOME_GROUP_2_YEAR_2008,
            HousingPermissionType.BAVARIA_EOF_INCOME_GROUP_2_YEAR_2012,
            HousingPermissionType.BAVARIA_EOF_INCOME_GROUP_2_YEAR_2018,
            HousingPermissionType.BAVARIA_EOF_INCOME_GROUP_2_YEAR_2023,
            HousingPermissionType.BAVARIA_EOF_INCOME_GROUP_3,
            HousingPermissionType.BAVARIA_EOF_INCOME_GROUP_3_YEAR_2008,
            HousingPermissionType.BAVARIA_EOF_INCOME_GROUP_3_YEAR_2012,
            HousingPermissionType.BAVARIA_EOF_INCOME_GROUP_3_YEAR_2018,
            HousingPermissionType.BAVARIA_EOF_INCOME_GROUP_3_YEAR_2023
          ])
        );
        break;
      case StateOfGermany.BERLIN:
        options.push(
          getWbsItems(state, [
            HousingPermissionType.WBS_100,
            HousingPermissionType.WBS_140,
            HousingPermissionType.WBS_160,
            HousingPermissionType.WBS_180,
            HousingPermissionType.WBS_220,
            HousingPermissionType.WBS_SPECIAL_HOUSING_NEEDS,
            HousingPermissionType.URGENCY_CERTIFICATE,
            HousingPermissionType.URGENCY_CONFIRMATION
          ])
        );
        break;
      case StateOfGermany.HAMBURG:
        options.push(
          getWbsItems(state, [
            HousingPermissionType.URGENCY_CERTIFICATE,
            HousingPermissionType.URGENCY_CONFIRMATION,
            HousingPermissionType.HAMBURG_THIRD_SUBSIDIZED_PATH
          ])
        );
        break;
      case StateOfGermany.LOWER_SAXONY:
        options.push(
          getWbsItems(state, [
            HousingPermissionType.LOWER_SAXONY_EIGHTH_PARAGRAPH
          ])
        );
        break;
      case StateOfGermany.SAXONY:
        options.push(
          getWbsItems(state, [
            HousingPermissionType.SAXONY_TWENTY_SIXTH_PARAGRAPH
          ])
        );
        break;
      case StateOfGermany.SCHLESWIG_HOLSTEIN:
        options.push(
          getWbsItems(state, [
            HousingPermissionType.SCHLESWIG_HOLSTEIN_EIGHTH_PARAGRAPH_STANDARD,
            HousingPermissionType.SCHLESWIG_HOLSTEIN_EIGHTH_PARAGRAPH_PLUS_20,
            HousingPermissionType.SCHLESWIG_HOLSTEIN_EIGHTH_PARAGRAPH_PLUS_40,
            HousingPermissionType.SCHLESWIG_HOLSTEIN_EIGHTY_EIGHTH_PARAGRAPH_D_2
          ])
        );
        break;
      case StateOfGermany.RHINELAND_PALATINATE:
        options.push(
          getWbsItems(state, [
            HousingPermissionType.RHINELAND_PALATINATE_SEVENTEENTH_PARAGRAPH_STANDARD,
            HousingPermissionType.RHINELAND_PALATINATE_SEVENTEENTH_PARAGRAPH_PLUS_40,
            HousingPermissionType.RHINELAND_PALATINATE_SEVENTEENTH_PARAGRAPH_PLUS_60
          ])
        );
        break;
      default:
        options.push(getWbsItems(state, []));
        break;
    }
  });

  return options;
};

const getWbsItems = (
  state: StateOfGermany,
  housingPermissionTypes: HousingPermissionType[]
): DropdownStepperParent<HousingPermissionType> => {
  const nationwideTypes: HousingPermissionType[] = [
    HousingPermissionType.WBS,
    HousingPermissionType.SIXTH_PARAGRAPH_SECOND_SUPPORT_PATH
  ];
  const types: HousingPermissionType[] = [
    ...nationwideTypes,
    ...housingPermissionTypes
  ];
  return {
    name: `states.germany.${state.toLowerCase()}_l`,
    items: types.map(housingPermissionType => ({
      name: `HOUSINGPERMISSIONTYPES_${housingPermissionType.toUpperCase()}`,
      value: housingPermissionType
    }))
  };
};
